import PropTypes from 'prop-types';

export const LABELS = {
  header: "label.login",
  userName: "label.user.profile.username",
  password: "label.user.account.setup.password.label",
  loginButton: "label.login",
  cancelButton: "label.cancel.button",
  signupButton: "label.login.signup.text",
  version: "label.version",
  multipleSessionsHeading: 'label.login.form.multi.session.heading',
  multipleSessionsText: 'label.login.form.multi.session.text',
  multipleSessionPasswordLabel: 'label.login.form.multi.session.pwd.label',
  eulaAgreementMessage: 'label.login.form.eulalicense.message',
  licenseAgreementText: 'label.login.form.eulalicense',
  multipleSessionLoginButton: 'label.login.form.multi.session.login.btn',
  forgotPassword: 'label.login.form.forgot.password',
  eulaNotAcceptedErrorMessage: 'label.login.eula.not.accepted.error',
  loginErrorMessage : 'label.login.credentials.error',
  sessionTimeoutErrorMessage: 'label.login.session.timeout.error',
  loginLockedErrorMessage: 'label.login.locked.error',
  contactAdminErrorMessage: 'label.login.contact.admin.error',
  unknownErrorMessage: 'label.login.unknown.error',
  credentialsErrorMessage: 'label.login.credentials.error',
};

export const TEST_IDS = {
  eulaNotAccepted: "error-eula-not-accepted-message",
  loginError: "error-login-message",
  sessionTimeout: "error-session-timeout-message",
  loginLocked: "error-login-lcked-message",
  contactAdmin: "error-contact-admin-message",
  unknownError: "error-unknown-error-message",
  credentialsError: "error-bad-credentials-message",
}

export const HELP_TEXTS = {
  firstName: "label.user.details.textfields.helptext",
  lastName: "label.user.details.textfields.helptext",
  userName: "label.user.account.setup.username.helptext",
  email: "label.user.account.setup.email.helptext",
  confirmPassword: "label.user.profile.password.match.error",
};

export const KEY_REFRESH_INTERVAL = 1 * 60 * 60;
export const UNKNOWN_ERROR = 'unknown-error';

export const ERRORS = {
  PASSWORD_EXPIRY: "PASSWORD_EXPIRY",
  MULTIPLE_SESSIONS: "MULTIPLE_SESSIONS",
  ERROR_CREDENTIALS: "ERROR_CREDENTIALS",
  ERROR_REDIRECT: "ERROR_REDIRECT",
  ERROR_REDIRECT_GENERIC: "ERROR_REDIRECT_GENERIC",
}

export const SchemeShape = {
  showFyp: PropTypes.bool,
  name: PropTypes.string,
  description: PropTypes.string,
  uuid: PropTypes.string,
  logo: PropTypes.string,
}